import { createFileRoute } from '@tanstack/react-router'
import { RequirePermission } from '@/shared/components'
import { CourierLedgerPage } from '@/pages/courier-ledger/CourierLedgerPage'

export const Route = createFileRoute('/courier-ledger')({
  component: () => (
    <RequirePermission section="tariffs" action="view_card">
      <CourierLedgerPage />
    </RequirePermission>
  ),
})
